module.exports = __webpack_public_path__ + "static/media/custom_icon_1.135506a5.png";